import axios from '@/axios.js'
import state from './state';
import specialistState from '../specialist/state';

export default {
    updateUnfinished({ commit }, dataPayment) {
        commit('UPDATE_UNFINISHED', dataPayment);
    },
    topup({ commit, dispatch }, data) {
        state.isLoading = true;
        axios.post('/client/payments/topup', {
            amount: data.amount
        })
        .then(function (response) {
            if(response.status == 200 && response.data.payment_ref) {
                var payment = {
                    currency: response.data.currency,
                    gateway: response.data.gateway,
                    payment_ref: response.data.payment_ref,
                    client_secret: response.data.client_secret,
                    payment_type: response.data.payment_type,
                    subtotal: response.data.subtotal,
                    total: response.data.total,
                    vat: response.data.vat,
                    entity: 'topup',
                    payload: data
                };
                commit('TOPUP', payment);
            }
            dispatch('notification/notification', response, {root: true});
            state.isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.isLoading = false;
        });
    },
    confirmPayment({ state, dispatch }, response) {
        dispatch('notification/notification', response, {root: true});
        switch (state.current.entity) {
            case 'booking': {
                state.current.entity = '';

                dispatch('specialist/clearBooking', {}, { root: true });
                dispatch('layout/widget', {}, { root: true });
                dispatch('user/user', {}, { root: true });
                break;
            }
            case 'topup': {
                console.log(state.current);
                dispatch('user/updateBalance', {
                    amount: state.current.payload.amount,
                    type: 'credit'
                }, {root: true })
                break;
            }
            case 'service': {
                dispatch('specialist/buyService', state.current.payload, {root: true})
                break;
            }
            case 'package': {
                dispatch('specialist/buyPackage', state.current.payload, {root: true})
                break;
            }
            case 'tips': {
                dispatch('meeting/sendTipToSpecialist', state.current.payload, {root: true})
                break;
            }
        }     
        state.isLoading = false;
        dispatch('closeModal');
    },
    check({ state, dispatch }, data) {
        state.isLoading = true;

        if (state.current.entity === 'booking') {
            dispatch('payPending', data);
            return;
        }

        if(state.current.entity === "package" || state.current.entity === "service" && specialistState.specialist != null){
            data.specialist_id = specialistState.specialist.id;
        }

        axios.post('/client/payments/stripe/check', data)
        .then(function (response) {
            dispatch('confirmPayment', response);
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.isLoading = false;
        });
    },
    closeModal({ commit, dispatch, state })  {
      commit('CLOSE_MODAL');
    },
    clientPaymentsAppearance({commit}, style) {
        commit('PAYMENTS_APPEARANCE', style);
    },
    async clientPayments({commit}) {
        state.paymentsLoading = true;
        axios.get('/client/payments')
          .then(function(response) {
            commit('CLIENT_PAYMENTS', response);
          })
    },
    /* Booking */
    async payPending({ dispatch, state }, data) {
      const body = {
        appointment_id: state.current.appointment.id,
        ref: data.ref,
        intent_id: data.intent_id
      };

      try {
        var response = await axios.post('/client/payments/stripe/check-pending', body);
      } catch (e) {
        var response = e.response;
      }

      dispatch('notification/notification', response, { root: true });
      state.isLoading = false;

      if (response.data.success === false) {
        return;
      }

      dispatch('confirmPayment', response);
    },
    openPayPending({ commit, dispatch }, data) {
      commit('PAY_PENDING', data);
    }
}
